<template>
  <HeaderActionButton :onPressed="onPressed">
    <template #icon>
      <v-icon>{{ themeIcon }}</v-icon>
    </template>
  </HeaderActionButton>
</template>

<script>
import HeaderActionButton from "@/views/home/components/HeaderActionButton.vue";
import { mapState } from "vuex";
export default {
  name: "SwitchThemeButton",
  components: {
    HeaderActionButton,
  },
  computed: {
    ...mapState("main", ["theme"]),
    themeIcon() {
      return this.theme === "dark" ? "mdi-weather-sunny" : "mdi-weather-night";
    },
  },
  methods: {
    onPressed() {
      this.$store.commit(
        "main/SET_THEME",
        this.theme === "dark" ? "light" : "dark"
      );
    },
  },
};
</script>